<template>
  <div class="row mt-2" style="height:100%">
    <div class="col-12">
      <div class="col-12 mb-2">
        <i class="fa fa-user" style="position: relative">
          <i class="fa fa-plus"></i>
        </i>
        {{ appointment.patient.firstName }}
        {{ appointment.patient.lastName }}
        <span class="pull-right"><i class="fa fa-calendar"></i>
          {{ getMediumDate(appointment.created) }}</span>
      </div>

      <iframe v-if="recordingsUrl" id="recordingViewerIFrame" :src="recordingsUrl" style="width:100%;height:90%;border:none;" @load="loader.hide()">
      </iframe>

      <!--       <div class="row" id="player-wrapper" :class="isFullscreen ? 'fullscreen' : ''" @click="showControls()">
        <fullscreen ref="fullscreen" @change="fullscreenChange" style="width: 100%">
          <div class="animated fadeIn" v-show="!PLAYING" id="play-toggle-btn">
            <n-button round icon type="primary" @click.native="play()" id="play-pause-button" v-show="!BUFFERING" style="
                z-index: 1;
                position: absolute;
                margin: auto;
                left: 0px;
                inset-inline-end: 0px;
                top: 55px;
              " size="lg">
              <i class="fa" :class="PLAYING ? 'fa-pause' : 'fa-play'"></i>
            </n-button>

            <div class="la-ball-scale-multiple la-3x" id="buffering-animation" v-show="BUFFERING">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>

          <div class="col-12 shadow-bottom">
            <div class="row">
              <div class="col-6" v-for="(participant, username) in selectedPlaylist" :key="username" style="background-color: black">
                <span class="full-name animated fadeIn" style="color: #fff; position: absolute" v-show="!PLAYING">{{ getFullName(username) }}</span>
                <video preload="auto" :src="participant.video" style="width: 100%"></video>
              </div>
            </div>
            <div class="slidecontainer">
              <div class="row slider-wrapper animated fadeIn" style="margin: 0" v-show="!PLAYING">
                <div class="col-10" style="color: #ffffffad; width: auto; font-size: 0.8em">
                  {{ elapsedTime }} / {{ duration }}
                </div>
                <div class="col-2 text-center" style="color: #ffffffad; font-size: 1.5em">
                  <i class="fa" @click="toggleFullscreen()" :class="isFullscreen ? 'fa-compress' : 'fa-expand'"></i>
                </div>
                <div class="col-12">
                  <input type="range" min="0" :max="sliderMaxValue" value="0" class="slider" id="myRange" step="0.01" v-model="sliderValue" @change="jumpTo()" />
                </div>
              </div>
            </div>
          </div>
        </fullscreen>
      </div>
      <div class="card-action playlist">
        <div class="col-12 playlist-item no-outline cursor-pointer" v-for="(playlist, index) in playlists" @click="selectPlaylist(playlist)" :key="index" :class="{
            highlight: playlist == selectedPlaylist,
          }">
          <div class="row">
            <div class="col-6 vertically-center">
              <n-button type="primary" @click.native="selectAndPlayPlaylist(playlist, $event)" round icon>
                <i class="fa fa-play"></i>
              </n-button>

              <span class="vertically-center pl-2 text-info"><i class="fa fa-clock"></i> {{ getTime(playlist) }}</span>
            </div>

            <div class="col-3" v-for="participant in playlist" style="width: auto">
              <video style="height: 3em; width: 5em; background-color: black">
                <source :src="participant.video+'#t=0.1'" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import "load-awesome/css/ball-scale-multiple.min.css";

export default {
  name: "recording-viewer",

  data() {
    return {
      playlists: [],
      elapsedTime: null,
      selectedPlaylist: null,
      duration: null,
      sliderValue: 0,
      sliderMaxValue: 0.01,
      isFullscreen: false,
      PLAYING: false,
      BUFFERING: false,
      loader: null,
    };
  },

  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
    recordingsUrl() {
      return this.$store.state.recordingsUrl;
    },
  },

  async mounted() {
    console.log(this.recordingsUrl);
    this.loader = this.$loading.show({
      container: null,
      canCancel: false,
    });
    /*     try {
      let data = await this.$store.dispatch("getRecordings", {
        instance: this.instance,
        appointmentId: this.appointment._id,
      });
      if (data && data.recordings && data.recordings.length > 0) {
        //Sort in descending order of date
        data.recordings.reverse();

        //Generating playlists with each recorded pair or more videos
        //Assuming each recorded session will have 2 videos one below the other
        for (let i = 0; i < data.recordings.length; i = i + 2) {
          let recording1 = data.recordings[i];
          let recording2 = data.recordings[i + 1];

          this.playlists.push({
            [recording1.participantName]: {
              timestamp: recording1.startDateTime,
              video: recording1.fileUrl,
            },
            [recording2.participantName]: {
              timestamp: recording2.startDateTime,
              video: recording2.fileUrl,
            },
          });
        }

        //Select the first playlist by default
        this.selectPlaylist(this.playlists[0]);
      }
    } catch (e) {
      console.log(e);
      swal.fire({
        type: "error",
        title: "Oops!",
        text: this.$t("message.There was a problem getting recordings"),
        timer: 5000,
      });
    } */
  },

  methods: {
    selectPlaylist(playlist) {
      //Disable auto play, because user has not clicked on play button
      $("#player-wrapper video").each((index, video) => {
        video.autoplay = false;
      });

      this.PLAYING = false;
      this.selectedPlaylist = playlist;

      //Using setinterval as it takes time to load the DOM with video tags and its video metadata
      let intervalHandle = setInterval(() => {
        //If first video tag is rendered
        if ($("#player-wrapper video")[0]) {
          clearInterval(intervalHandle);

          //If video data is not loaded
          if (isNaN($("#player-wrapper video")[0].duration)) {
            //Wait for onloadeddata event
            $("#player-wrapper video")[0].onloadeddata = (event) => {
              let time = moment.duration(
                event.target.duration,
                "seconds"
              )._data;
              this.duration =
                ("0" + time.minutes).slice(-2) +
                ":" +
                ("0" + time.seconds).slice(-2);
              this.sliderMaxValue = event.target.duration;

              this.elapsedTime = "00:00";
            };
          } else {
            let time = moment.duration(
              $("#player-wrapper video")[0].duration,
              "seconds"
            )._data;
            this.duration =
              ("0" + time.minutes).slice(-2) +
              ":" +
              ("0" + time.seconds).slice(-2);
            this.sliderMaxValue = $("#player-wrapper video")[0].duration;
            this.elapsedTime = "00:00";
          }

          //Listening to ontimeuopdate event to updated slider and elapsed time
          $("#player-wrapper video")[0].ontimeupdate = (event) => {
            this.sliderValue = event.target.currentTime.toFixed(2);
            let time = moment.duration(
              event.target.currentTime,
              "seconds"
            )._data;
            this.elapsedTime =
              ("0" + time.minutes).slice(-2) +
              ":" +
              ("0" + time.seconds).slice(-2);
          };

          //If video is ended or throws error, move to next playlist
          $("#player-wrapper video")[0].onended = () => {
            this.selectNextPlaylist();
          };
          $("#player-wrapper video")[0].onerror = () => {
            this.selectNextPlaylist();
          };

          //Start listenig to Waiting event when video starts buffering
          this.registerWaitingListener();
        }
      }, 500);
    },
    getMediumDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getFullName(username) {
      if (
        this.appointment.attendant &&
        this.appointment.attendant.username == username
      ) {
        return (
          this.appointment.attendant.firstName +
          " " +
          this.appointment.attendant.lastName
        );
      } else if (this.appointment.provider.username == username) {
        return (
          this.appointment.provider.firstName +
          " " +
          this.appointment.provider.lastName
        );
      } else {
        return username;
      }
    },
    //Get time value from playlist's timestamp
    getTime(playlist) {
      let timestampArray = [];

      //Each playlist will have videos with particpant details and timestamp
      //Generating timestmap array with all timestamps in the playlist
      for (let participantName in playlist) {
        let participant = playlist[participantName];
        timestampArray.push(participant.timestamp);
      }

      timestampArray.sort();
      return moment(timestampArray[timestampArray.length - 2]).format(
        "h:mm:ss a"
      );
    },
    registerWaitingListener() {
      //Register waiting eventlistener for all videos in selected playlist
      $("#player-wrapper video").each((index, videoelement) => {
        videoelement.onwaiting = (event) => {
          if (!this.BUFFERING) {
            this.BUFFERING = true;
            //Pause all videos
            this.play();

            //Check buffered section of all videos
            //Using setInterval to wait until buffered section is more than 10 secs of all videos
            let intervalHandle = setInterval(() => {
              let bufferedTimesInSecs = [];

              $("#player-wrapper video").each((index, _videoelement) => {
                //Sync all the videos first
                _videoelement.currentTime = videoelement.currentTime;

                //If remaining video is more than 9 secs
                if (_videoelement.duration - _videoelement.currentTime > 9) {
                  bufferedTimesInSecs.push(
                    moment.duration(
                      _videoelement.buffered.end(0) - _videoelement.currentTime,
                      "seconds"
                    )._data.seconds
                  );
                } else {
                  bufferedTimesInSecs.push(10);
                }
              });

              //Check if any video has less than 10 secs buffered section
              let bufferLessThan10Secs = bufferedTimesInSecs.find((time) => {
                return time < 10;
              });

              //If not
              if (!bufferLessThan10Secs) {
                $("#player-wrapper video").each((index, __video) => {
                  //Remove Waiting event listeners
                  __video.onwaiting = null;
                });

                clearInterval(intervalHandle);

                setTimeout(() => {
                  this.play();
                  this.registerWaitingListener();
                  this.BUFFERING = false;
                }, 1000);
              }
            }, 500);
          }
        };
      });
    },
    fullscreenChange(fullscreen) {
      this.isFullscreen = fullscreen;
    },
    toggleFullscreen() {
      this.$refs["fullscreen"].toggle();
    },
    play() {
      if (!this.PLAYING) {
        this.PLAYING = true;
        $("#player-wrapper video").each((index, video) => {
          video.play();
        });
      } else {
        this.PLAYING = false;
        $("#player-wrapper video").each((index, video) => {
          video.pause();
        });
      }
    },
    selectNextPlaylist() {
      this.PLAYING = false;
      let playlistIndexToSelect =
        this.playlists.indexOf(this.selectedPlaylist) + 1;
      if (playlistIndexToSelect < this.playlists.length) {
        this.selectPlaylist(this.playlists[playlistIndexToSelect]);
      }
    },
    showControls() {
      if (this.PLAYING) {
        $("#player-wrapper").addClass("active");

        setTimeout(() => {
          if (this.PLAYING) {
            $("#player-wrapper").removeClass("active");
          }
        }, 2000);
      }
    },
    jumpTo() {
      $("#player-wrapper video").each((index, video) => {
        video.currentTime = this.sliderValue;
      });
    },
    selectAndPlayPlaylist(playlist, event) {
      if (this.selectedPlaylist == playlist) {
        this.play(); // to play video after selecting a playlist
      }
      event.stopPropagation();
      this.PLAYING = true;
      this.selectedPlaylist = playlist;

      //Enable autoplay to start playing video automatically after selection
      $("#player-wrapper video").each((index, video) => {
        video.autoplay = true;
      });
    },
  },
};
</script>

<style scoped>
/deep/ .slidecontainer {
  width: 100%;
  background: black;
  min-height: 5em;
}

#player-wrapper.active #play-toggle-btn,
#player-wrapper.active .full-name,
#player-wrapper.active .slider-wrapper,
#player-wrapper:active #play-toggle-btn,
#player-wrapper:active .full-name,
#player-wrapper:active .slider-wrapper {
  display: flex !important;
}

video {
  border-radius: 10px;
}

.playlist-item {
  padding-top: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid #b9b5b5;
}

.playlist {
  height: 20em;
  overflow-y: scroll;
}

.card-heading {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  font-size: 1em;
}

.fa-user {
  font-size: 1.5em;
}

.fa-user .fa-plus {
  font-size: 0.4em;
  position: relative;
  inset-inline-end: 15px;
  color: #fff;
}

/* The slider itself */
.slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 10px;
  background: #d3d3d3;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  border-radius: 19px;
  display: inline-block;
  margin-bottom: 13px;
  overflow: hidden;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  background: var(--color-primary);
  cursor: pointer;
  border-radius: 19px;
  box-shadow: -502px 0 0 500px #f964325b;
}

#play-toggle-btn,
#buffering-animation {
  position: absolute;
  z-index: 1;
  left: 0;
  inset-inline-end: 0;
  margin-left: auto;
  margin-right: auto;
  top: 90px;
  transform: translateY(-50%);
}

#player-wrapper video {
  height: 285px;
  width: 100%;
}

#player-wrapper.fullscreen video {
  height: 47em;
}

.highlight {
  background-color: #80808038;
}
</style>
